import { Button, Flex, Typography } from 'antd';
import { FC } from 'react';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

import { AppMessage, CircleSpinnerIcon, HiddenPassword } from '@/common/components';
import { messageOnError } from '@/common/utils';

import { useGetPasswordForDomainRegistrarAccountsMutation } from '@/modules/DomainRegistrars';

type Props = {
  domainRegistrarId: string;
  domainRegistrarAccountId: string;
};

export const DomainRegistrarsAccountHiddenPassword: FC<Props> = ({ domainRegistrarId, domainRegistrarAccountId }) => {
  const appMessageApi = AppMessage.useControls();

  const { data, isSuccess, isLoading, error, isError, refetch } = useGetPasswordForDomainRegistrarAccountsMutation(
    domainRegistrarId,
    domainRegistrarAccountId,
  )({
    enabled: true,
    onError: (error) => {
      if (error.response?.status !== 403) messageOnError(error, appMessageApi);
    },
  });

  const handleRefetch = () => {
    refetch();
  };

  if (isLoading) {
    return <CircleSpinnerIcon />;
  }

  if (isError) {
    return error.response?.status === 403 ? (
      <>
        <ExclamationTriangleFill size={16} color="#faad14" />
        &nbsp;
        <Typography.Text type="warning">Доступ заборонено</Typography.Text>
      </>
    ) : (
      <Button type="dashed" onClick={handleRefetch} color="red">
        спробувати знову
      </Button>
    );
  }

  if (isSuccess) {
    return <HiddenPassword key="password" password={data.password} />;
  }

  return <></>;
};
